import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { Tracking } from '@app/services/tracking/tracking.service';
import { PortalTrackingEvents } from '@app/utils/tracking-events';
import { CommonDataService } from '@app/services/common-data/common-data.service';

@Component({
  selector: 'continue-with-email-modal',
  templateUrl: './continue-with-email-modal.component.html',
  styleUrls: ['./continue-with-email-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContinueWithEmailModalComponent implements OnChanges {
  form: FormGroup = new FormGroup({
    email: new FormControl('', { validators: [Validators.required, Validators.email] }),
  });

  loading: boolean;
  protected commonDataService = inject(CommonDataService);

  @Input() activationError: string | null;

  @Output() hideModal = new EventEmitter();
  @Output() sendEmail = new EventEmitter();

  @HostListener('document:keydown.enter') onEnter() {
    this.submit();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (typeof changes['activationError']?.currentValue === 'string') {
      this.loading = false;

      this.form.enable();
      this.form.setErrors({});
    }
  }

  focus() {
    Tracking.track(PortalTrackingEvents.portalContinueWithEmailInputFocused);
  }

  submit() {
    this.loading = true;

    this.form.disable();

    const value = this.form.get('email')?.value as string;

    this.sendEmail.emit(value?.toLowerCase());

    Tracking.track(PortalTrackingEvents.portalContinueWithEmailInputSubmitted);
  }
}
